export const go = route => {
  const event = new CustomEvent('routechange', { detail: {route} });
  window.dispatchEvent(event)
}